/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Milestone_HeadlineInputs */

const en_us2_share_milestone_headline = /** @type {(inputs: Share_Milestone_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`workouts done`)
};

const pt_br2_share_milestone_headline = /** @type {(inputs: Share_Milestone_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`treinos concluídos`)
};

const es_419_share_milestone_headline = /** @type {(inputs: Share_Milestone_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`entrenamientos completados`)
};

const pt_pt2_share_milestone_headline = /** @type {(inputs: Share_Milestone_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`treinos concluídos`)
};

const fr_fr2_share_milestone_headline = /** @type {(inputs: Share_Milestone_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`séances terminées`)
};

const de_de2_share_milestone_headline = /** @type {(inputs: Share_Milestone_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainings geschafft`)
};

const it_it2_share_milestone_headline = /** @type {(inputs: Share_Milestone_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`allenamenti completati`)
};

/**
* | output |
* | --- |
* | "workouts done" |
*
* @param {Share_Milestone_HeadlineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_milestone_headline = /** @type {((inputs?: Share_Milestone_HeadlineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Milestone_HeadlineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_milestone_headline(inputs)
	if (locale === "es-419") return es_419_share_milestone_headline(inputs)
	if (locale === "pt-PT") return pt_pt2_share_milestone_headline(inputs)
	if (locale === "fr-FR") return fr_fr2_share_milestone_headline(inputs)
	if (locale === "de-DE") return de_de2_share_milestone_headline(inputs)
	if (locale === "it-IT") return it_it2_share_milestone_headline(inputs)
	return en_us2_share_milestone_headline(inputs)
});
export { share_milestone_headline as "share.milestone_headline" }